/* Configuration constants for LiveChat: progress steps, keywords, and patterns */

export const AGENT_ID = process.env.REACT_APP_ELEVENLABS_AGENT_ID;
export const XI_KEY = process.env.REACT_APP_ELEVENLABS_API_KEY;

/**
 * Progress bar step definitions shown to the user during the conversation.
 */
export const PROGRESS_STEPS = [
  {
    label: 'Functietitel',
    title: 'Wat zoeken we',
    description: 'Jesse heeft begrepen welke functie je wilt invullen'
  },
  {
    label: 'Werkzaamheden',
    title: 'Wat gaat iemand doen',
    description: 'Belangrijkste taken en werkzaamheden zijn besproken'
  },
  {
    label: 'Voordelen',
    title: 'Waarom wil iemand dit',
    description: 'Voordelen voor sollicitant zijn geidentificeerd'
  },
  {
    label: 'Functie-eisen',
    title: 'Wat moet iemand kunnen',
    description: 'Eisen en vereisten zijn vastgesteld'
  },
  {
    label: 'Arbeidsvoorwaarden',
    title: 'Wat bieden jullie',
    description: 'Salaris en arbeidsvoorwaarden zijn bepaald'
  }
];

/**
 * ~200 Dutch job-related keywords grouped by industry sector.
 * Used in step 0→1 detection: if the user mentions any of these,
 * we know they've identified a job title.
 */
export const JOB_KEYWORDS = [
  // ALGEMENE WERK/FUNCTIE TERMEN
  'functie', 'vacature', 'baan', 'werk', 'job', 'zoek', 'positie', 'rol',
  'sollicitatie', 'werknemer', 'medewerker', 'persoon', 'iemand', 'kandidaat',
  'werkgelegenheid', 'carriere', 'loopbaan', 'emploi', 'werkplek', 'betrekking',

  // BOUW & TECHNIEK
  'fietsenmaker', 'fietsen', 'repareren', 'fiets', 'tweewieler',
  'bouwvakker', 'bouwen', 'constructie', 'bouw', 'metselaar', 'timmerman',
  'electricien', 'elektricien', 'elektrisch', 'installateur', 'loodgieter',
  'schilder', 'behanger', 'monteur', 'technicus', 'onderhoud', 'reparatie',
  'montage', 'installatie', 'servicemonteur', 'storingsmonteur', 'mechanicus',
  'automonteur', 'automechanicus', 'garage', 'werkplaats', 'gereedschap',
  'soldaat', 'lasser', 'machinist', 'kraan', 'hijskraan', 'bulldozer',
  'grondwerker', 'wegenbouw', 'aannemer', 'architect', 'constructeur',
  'tekenaar', 'calculator', 'werkvoorbereider', 'projectleider bouw',

  // IT & TECHNOLOGIE
  'developer', 'programmeur', 'software', 'app', 'website', 'web',
  'frontend', 'backend', 'fullstack', 'javascript', 'python', 'java',
  'react', 'angular', 'vue', 'node', 'php', 'sql', 'database',
  'devops', 'sysadmin', 'systeembeheerder', 'netwerk', 'security',
  'cybersecurity', 'hacker', 'tester', 'qa', 'scrum master', 'agile',
  'product owner', 'ux', 'ui', 'designer', 'grafisch', 'webdesign',
  'data scientist', 'data analist', 'machine learning', 'ai', 'artificial',
  'cloud', 'aws', 'azure', 'kubernetes', 'docker', 'git', 'github',
  'mobile', 'ios', 'android', 'flutter', 'react native', 'swift',
  'unity', 'game', 'blockchain', 'cryptocurrency', 'fintech',

  // HORECA & SERVICE
  'kok', 'chef', 'keuken', 'restaurant', 'cafe', 'bar', 'horeca',
  'barista', 'koffie', 'cappuccino', 'espresso', 'latte',
  'ober', 'serveerster', 'bediening', 'service', 'gastronomie',
  'sommelier', 'wijn', 'bartender', 'mixoloog', 'cocktail',
  'afwasser', 'keukenhulp', 'commis', 'sous chef', 'patissier',
  'bakker', 'banketbakker', 'brood', 'gebak', 'taart', 'croissant',
  'slager', 'vlees', 'worst', 'ham', 'kaas', 'delicatessen',
  'catering', 'evenement', 'feest', 'bruiloft', 'partycatering',
  'hotel', 'receptionist', 'concierge', 'kamermeisje', 'huishoudster',

  // ZORG & WELZIJN
  'verpleegkundige', 'verpleger', 'zuster', 'broeder', 'zorg', 'zorgen',
  'arts', 'dokter', 'specialist', 'huisarts', 'medisch', 'geneeskunde',
  'tandarts', 'mondhygienist', 'orthodontist', 'tanden', 'gebit',
  'fysiotherapeut', 'fysio', 'massage', 'revalidatie', 'beweging',
  'psycholoog', 'psychiater', 'therapie', 'counseling', 'ggz',
  'apotheker', 'apotheek', 'medicijnen', 'farmaceutisch',
  'verzorgende', 'thuiszorg', 'wijkverpleging', 'mantelzorg',
  'begeleider', 'gehandicaptenzorg', 'ouderenzorg', 'jeugdzorg',
  'maatschappelijk werker', 'sociaal werk', 'hulpverlening',

  // ONDERWIJS
  'leraar', 'docent', 'onderwijzer', 'juf', 'meester', 'onderwijs',
  'basisschool', 'middelbare school', 'universiteit', 'hogeschool',
  'vmbo', 'havo', 'vwo', 'mbo', 'hbo', 'wo', 'studie', 'student',
  'professor', 'lecturer', 'trainer', 'instructeur', 'coach',
  'kleuterjuf', 'peuterleidster', 'kinderopvang', 'creche', 'bso',
  'bibliothecaris', 'museum', 'cultuur', 'educatie', 'kennis',

  // TRANSPORT & LOGISTIEK
  'chauffeur', 'bestuurder', 'vrachtwagen', 'truck', 'bus', 'taxi',
  'bezorger', 'koerier', 'postbode', 'pakketbezorger', 'delivery',
  'magazijnmedewerker', 'magazijn', 'warehouse', 'opslag', 'logistiek',
  'vorkheftruck', 'reachtruck', 'orderpicker', 'picker', 'packer',
  'expeditie', 'verzending', 'planning', 'dispatcher', 'routing',
  'conducteur', 'machinist', 'trein', 'spoor', 'ns', 'ov',
  'vliegtuig', 'piloot', 'steward', 'stewardess', 'luchtvaart',
  'haven', 'scheepvaart', 'container', 'laden', 'lossen',

  // VERKOOP & MARKETING
  'verkoper', 'verkoopster', 'verkoop', 'sales', 'winkel', 'retail',
  'kassier', 'kassiere', 'kassa', 'winkelbediende', 'adviseur',
  'account manager', 'key account', 'business development', 'hunter',
  'marketing', 'marketeer', 'campagne', 'reclame', 'advertentie',
  'social media', 'content', 'copywriter', 'seo', 'sem', 'google ads',
  'pr', 'communicatie', 'pers', 'journalist', 'redacteur',
  'telemarketing', 'callcenter', 'klantenservice', 'helpdesk',
  'ecommerce', 'webshop', 'online', 'digital', 'influencer',

  // KANTOOR & ADMINISTRATIE
  'administratief', 'administratie', 'admin', 'kantoor', 'bureau',
  'secretaresse', 'assistent', 'office manager', 'receptionist',
  'boekhouder', 'accountant', 'financieel', 'belasting', 'btw',
  'hr', 'personeelszaken', 'recruitment', 'recruiter', 'headhunter',
  'manager', 'teamleider', 'supervisor', 'coordinator', 'planner',
  'controller', 'analyst', 'consultant', 'adviseur', 'specialist',
  'project manager', 'projectleider', 'scrum master', 'agile coach',
  'data entry', 'invoer', 'typist', 'archivering', 'filing',

  // CREATIEF & MEDIA
  'grafisch ontwerper', 'designer', 'vormgever', 'creative', 'art director',
  'fotograaf', 'camera', 'video', 'film', 'montage', 'editor',
  'illustrator', 'tekenaar', 'kunstenaar', 'schilder', 'beeldhouwer',
  'muzikant', 'musicus', 'band', 'artiest', 'performer', 'zanger',
  'dj', 'producer', 'geluidstechnicus', 'sound', 'studio',
  'schrijver', 'auteur', 'redacteur', 'journalist', 'blogger',
  'acteur', 'actrice', 'theater', 'toneel', 'cabaret', 'comedy',
  'make up artist', 'visagist', 'stylist', 'kapper', 'schoonheid',

  // VEILIGHEID & HANDHAVING
  'beveiliger', 'security', 'beveiliging', 'bewaking', 'portier',
  'politie', 'agent', 'handhaving', 'boa', 'parkeercontroleur',
  'brandweer', 'brandweerman', 'ambulance', 'paramedicus', 'ehbo',
  'militair', 'soldaat', 'defensie', 'leger', 'marine', 'luchtmacht',

  // SCHOONMAAK & ONDERHOUD
  'schoonmaker', 'schoonmaak', 'cleaning', 'poetsen', 'dweil',
  'glazenwasser', 'ramen', 'gevel', 'hoogwerker', 'steiger',
  'tuinman', 'tuinarchitect', 'tuin', 'groen', 'plant', 'boom',
  'maaien', 'snoeien', 'hovenier', 'park', 'gemeente',
  'concierge', 'huismeester', 'facility', 'onderhoud', 'reparatie'
];

/**
 * Step detection patterns: Jesse's response must contain one of these
 * phrases to trigger progress from step N to step N+1.
 */
export const STEP_PATTERNS = {
  // Step 1→2: Jesse asks about tasks/activities
  step2: [
    'wat gaat', 'wat worden', 'wat zijn de taken', 'wat doet',
    'welke taken', 'wat voor werk', 'welke werkzaamheden',
    'wat houdt het in', 'wat zijn de activiteiten',
    'dagelijkse taken', 'hoofdtaken', 'kerntaken',
    'verantwoordelijkheden', 'wat verwacht je',
    'concrete voorbeelden', 'geef eens een voorbeeld',
    'wat ga je doen', 'wat gaat iemand doen',
    'waar bestaat het werk uit', 'wat is de rol',
    'wat komt er bij kijken', 'welke werkzaamheden',
    'wat voor activiteiten', 'wat doe je dan precies'
  ],
  // Step 2→3: Jesse asks about benefits/appeal
  step3: [
    'waarom zou', 'wat maakt', 'waarom interessant', 'voordelen',
    'waarom kiezen', 'waarom hier werken', 'wat biedt de functie',
    'wat maakt het aantrekkelijk', 'leuke aspecten', 'pluspunten',
    'wat spreekt aan', 'waarom solliciteren', 'wat trekt aan',
    'unieke kanten', 'bijzondere aspecten', 'wat maakt het leuk',
    'waarom zouden mensen', 'wat is er mooi aan', 'charme van',
    'aantrekkelijke kanten', 'positieve aspecten', 'wat biedt het'
  ],
  // Step 3→4: Jesse asks about requirements
  step4: [
    'waar moet', 'welke eisen', 'wat vereist', 'wat is nodig',
    'opleiding', 'ervaring', 'jaren ervaring', 'werkervaring',
    'vaardigheden', 'competenties', 'kwalificaties', 'diploma',
    'wat moet kunnen', 'welke kennis', 'wat verwachten we',
    'minimale eisen', 'vereisten', 'profiel', 'geschikt profiel',
    'ideale kandidaat', 'wie zoeken we', 'wat moet je hebben',
    'voorwaarden', 'technische eisen', 'soft skills', 'hard skills'
  ],
  // Step 4→5: Jesse asks about employment terms
  step5: [
    'wat staat er voor', 'wat biedt', 'wat krijgt', 'wat kunnen jullie bieden',
    'arbeidsvoorwaarden', 'voorwaarden', 'salaris', 'loon', 'verdienen',
    'locatie', 'adres', 'waar', 'werktijden', 'uren',
    'contract', 'vast', 'tijdelijk', 'parttime', 'fulltime',
    'vakantiedagen', 'pensioen', 'lease auto', 'reiskostenvergoeding',
    'secundaire voorwaarden', 'extraatjes', 'benefits', 'voordelen werkgever',
    'wat bieden wij', 'ons aanbod', 'jouw pakket'
  ]
};

/**
 * Phrases that signal Jesse has started generating the final vacancy text.
 */
export const VACANCY_COMPLETION_PATTERNS = [
  'hier is de vacaturetekst', 'vacaturetekst opstellen',
  'tijd om die vacaturetekst te bakken', 'alle ingredienten binnen',
  'hier komt ie', 'op basis van ons gesprek'
];
